// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayChipsSkeleton-modulechip__4mQX9 Skeleton-moduleSkeleton__Mlrfv";
var _2 = "CalendarGridDayChipsSkeleton-modulechipShort__uaeEX CalendarGridDayChipsSkeleton-modulechip__4mQX9 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "chip", _2 as "chipShort" }
